<template>
  <a-modal
    v-model="isVisible"
    :title="showTitle"
    :footer="showFooter"
    :maskClosable="!!maskClosable"
    :keyboard="!!keyboard"
    :class="['b-modal', size ? size : 'default']"
    :width="width"
    :closable="isShowCloseButton"
    :centered="isOpenCentered"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <slot></slot>
  </a-modal>
</template>

<script>
export default {
  name: 'b-modal',
  components: {},
  props: ['visible', 'title', 'footer', 'size', 'width', 'maskClosable', 'closable', 'centered', 'keyboard'],
  data() {
    return {
      isVisible: false
    }
  },
  beforeMount() {
    if (this.visible) {
      this.isVisible = this.visible
    }
  },
  watch: {
    visible(value) {
      this.isVisible = value
    }
  },
  mounted() {},
  computed: {
    showTitle() {
      return this.title ? this.title : null
    },
    showFooter() {
      return this.footer ? this.footer : null
    },
    isShowCloseButton() {
      return this.closable !== undefined ? this.closable : true
    },
    isOpenCentered() {
      return this.centered !== undefined ? this.centered : false
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel', false)
    },
    handleOk() {
      this.$emit('ok', false)
    }
  }
}
</script>

<style lang="scss">
:v-deep() .b-modal.default-plus .ant-modal {
  width: 580px !important;
}
</style>
